import { Box, Center, Flex, Stack, useMantineTheme } from "@mantine/core";
import { PropsWithChildren, ReactElement } from "react";
import Wordmark from "@common/components/icons/Wordmark";
import { useContentStyles } from "./CenteredLayout.styled";
import { ICenteredLayoutProps } from "./types";

export default function CenteredLayout({
  maxWidth,
  padding,
  wordmark,
  h,
  mih,
  w,
  children,
}: PropsWithChildren<ICenteredLayoutProps>): ReactElement {
  const theme = useMantineTheme();
  const { classes } = useContentStyles({ padding });

  return (
    <Flex
      direction="column"
      h={h}
      mih={mih || { base: "auto", sm: "100vh" }}
      w={w || "100%"}
    >
      {wordmark && (
        <Center py="xs">
          <Wordmark />
        </Center>
      )}
      <Center className={classes.root}>
        <Stack maw={maxWidth || theme.breakpoints.xs} w="100%">
          {children}
        </Stack>
      </Center>
    </Flex>
  );
}

function CenteredLayoutNew({
  maxWidth,
  padding,
  wordmark,
  h,
  mih,
  w,
  children,
}: PropsWithChildren<ICenteredLayoutProps>): ReactElement {
  const theme = useMantineTheme();
  const { classes } = useContentStyles({ padding });

  return (
    <Box
      bg="gray.0"
      className={classes.root}
      h={h}
      mih={mih || { base: "auto", sm: "100vh" }}
      w={w || "100%"}
      p="10px"
    >
      <Center>
        <Stack maw={maxWidth || theme.breakpoints.xs} w="100%" h="100%">
          {wordmark && (
            <Center py="xs" my={{ base: "0", sm: "60px" }} h="100%">
              <Wordmark.WithText />
            </Center>
          )}
          <Center>
            <Stack maw={maxWidth || theme.breakpoints.xs} w="100%">
              {children}
            </Stack>
          </Center>
        </Stack>
      </Center>
    </Box>
  );
}

CenteredLayout.New = CenteredLayoutNew;
